import axios from 'axios';

import { CompanyRegistrationPayload } from '@/types/api/auth';

export const registerCompany = async (
	registrationData: CompanyRegistrationPayload,
): Promise<CompanyRegistrationPayload> => {
	try {
		const { data } = await axios.post<CompanyRegistrationPayload>(
			`${process.env.HOST}/accounts/registration/`,
			registrationData,
		);
		return data;
	} catch (error) {
		console.error(error);
		throw error?.response?.data ?? 'Ошибка при регистрации компании';
	}
};
